import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, dateFormatter, substringFormatter } from '../../../components/tables/table'
import { getMultimedia, deleteMultimedia } from '../../../../api/multimedia'
import { Button, Tooltip, Chip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData (items) {
  let data = []
  for (let i = 0; i < items.length; ++i) {
    const elem = {}
    elem.key = items[i].key || ''
    elem.type = items[i].type || ''
    elem.imageUrl = items[i].imageUrl || ''
    elem.videoUrl = items[i].videoUrl || ''
    elem.createdAt = items[i].createdAt
    elem.id = items[i]._id
    data = data.concat(elem)
  }
  return data
}

export default function MultimediaPage () {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter (cell) {
    return (<>
      <Tooltip title='Editar'>
        <Button
          style={buttonsStyle} size='small'
          onClick={() => history.push('/edit-multimedia/' + cell)}>
          <EditIcon />
        </Button>
      </Tooltip>
      <Tooltip title='Eliminar'>
        <Button
          style={buttonsStyle} size='small'
          onClick={async () => {
            if (!window.confirm('¿Seguro que quieres eliminar este elemento?')) return
            try {
              await deleteMultimedia(cell)
              alertSuccess({ customMessage: 'Elemento eliminado correctamente.' })
              setRefresh(!refresh)
            } catch (error) {
              alertError({ error, customMessage: 'No se pudo eliminar el elemento.' })
            }
          }}>
          <DeleteIcon />
        </Button>
      </Tooltip>
    </>)
  }

  const keyFormatter = (cell) => {
    if (!cell) return <span style={{ color: '#9ca3af' }}>—</span>
    return (
      <Chip
        label={cell}
        size='small'
        style={{ backgroundColor: '#e0f2fe', color: '#0369a1', fontFamily: 'monospace' }}
      />
    )
  }

  const urlFormatter = (cell) => {
    if (!cell) return <span style={{ color: '#9ca3af' }}>—</span>
    // Si es base64, mostrar solo el comienzo para no llenar la tabla
    if (typeof cell === 'string' && cell.startsWith('data:')) {
      return <span style={{ fontFamily: 'monospace' }}>{cell.substring(0, 30)}...</span>
    }
    // Para URLs normales usamos el substringFormatter genérico
    return substringFormatter(cell)
  }

  const columns = [
    { dataField: 'key', text: 'Clave', sort: true, formatter: keyFormatter, headerStyle: { width: '160px' } },
    { dataField: 'type', text: 'Tipo', sort: true, headerStyle: { width: '120px' } },
    { dataField: 'imageUrl', text: 'Imagen', sort: false, formatter: urlFormatter },
    { dataField: 'videoUrl', text: 'Vídeo', sort: false, formatter: urlFormatter },
    {
      dataField: 'createdAt',
      text: 'Creado',
      formatter: dateFormatter,
      sort: true
    },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getMultimedia().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get multimedia.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Multimedia'>
          <CardHeaderToolbar>
            <Button
              type='button'
              className='btn btn-primary'
              onClick={() => history.push('/edit-multimedia')}
            >
              Añadir multimedia
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  )
}


